export const getJewelryCategoryFromPath = (fullPath: string): string | null => {
  const path = fullPath.split(/[?#]/)[0]
  const segments = path.split('/').filter(Boolean)

  if (segments[0] !== 'jewelry') {
    return null
  }

  const category = segments[1]
  if (!category || category === 'filter' || /^\d+$/.test(category)) {
    return null
  }

  return category
}
